export var globalJson: any = {
  company_id: null,

  //social links
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/",

  //contact
  address: "N/A",
  operating_time: "",
  addressLink: "N/A",
  phone: "N/A",
  email: "N/A",
  company_name: "Car Rental",
};

